module.exports = __webpack_public_path__ + "img/chevron-down.37be62b6.svg";